const initialState = {
    lang:'English',
    sources:[],
    briefType:'text',
    output:'text',
    response:'',
    query:'',
    suggestions:true,
    isInputShow:true,
    isLoading:false,
    id:'',
    phase:0,
    planningBreakdown:'',
    isOpen:false,
    links:"",
    isIframe:false,
    internalSources:[],
    externalSources:[],
    fromSearch:false,
    files:[]
}

const briefReducers = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'briefSourceChange':
        // console.log(payload)
        state = { ...state, sources: payload};
        return state;
    case 'briefLangChange':
        state = { ...state, lang: payload};
        return state;
    case 'briefQueryChange':
        state = { ...state, query: payload};
        return state;
    case 'briefPanningBreakdownChange':
        // console.log(payload);
        state = { ...state,planningBreakdown:payload};
        return state;
    case 'briefRespChange':
        state = { ...state, response: payload};
        return state;
    case 'briefisInputShowChange':
        state = { ...state, phase: payload};
        return state;
    case 'briefIsLoadingChange':
        state = { ...state, isLoading: payload};
        return state;
    case 'briefAgenticIdChange':
        state = { ...state, id: payload};
        return state;
    case 'briefAgenticIsOpen':
        state = { ...state, isOpen: payload};
        return state;
    case 'briefAgenticIsIframe':
        state = { ...state, isIframe: payload};
        return state;
    case "newBriefChange":
        state = { ...initialState,externalSources:state.externalSources, internalSources:state.internalSources};
        return state;
    case "briefAgentTargetUrlChange":
        state = { ...state, links: payload};
        return state;
    case 'briefOutputChange':
        state = { ...state, briefType: payload};
        return state;
    case 'briefInternalSourceChange':
        state = { ...state, internalSources: payload};
        return state;
    case 'briefExternalSourceChange':
        state = { ...state, externalSources: payload};
        return state;
    case 'briefFromSeaerchChange':
        state = { ...state, fromSearch: payload};
        return state;
    case 'briefAttchmentChange':
        console.log("payload",payload);
        state = { ...state, files: payload};
        return state;
    default:
    return state
  }
}

export default briefReducers;
